import { createRoot } from 'react-dom/client'
import App from './App.tsx'
import { AppProviders } from './providers/AppProviders'
import { ErrorBoundary } from './components/shared/ErrorBoundary'
import { setCfAccountHash, setR2PublicBase } from '@pocketbloom/shared'
import './index.css'

// Initialize CF Images account hash for image URL resolution
setCfAccountHash(import.meta.env.VITE_CF_IMAGES_ACCOUNT_HASH || '')
// Rewrite raw r2.dev URLs → custom domain (Cloudflare R2 Custom Domain)
setR2PublicBase('https://media.sentiflor.az/')

createRoot(document.getElementById('root')!).render(
  <ErrorBoundary>
    <AppProviders>
      <App />
    </AppProviders>
  </ErrorBoundary>
)

